import { create } from "zustand";
import { persist } from "zustand/middleware";

export type TopNavigationDisplay = "icons-text" | "icons";

type TopNavigationState = {
  display: TopNavigationDisplay;
  setDisplay: (display: TopNavigationDisplay) => void;
};

export const useTopNavigationStore = create<TopNavigationState>()(
  persist(
    (set) => ({
      display: "icons-text",

      setDisplay: (display) => set({ display }),
    }),
    {
      name: "top-navigation-storage-v1",
    },
  ),
);
